import React, { useState, useEffect } from 'react';
import Loader from '../manageAccount/accountLoader';
import { apiUrl } from '../common/constants';
import { GetRequest, getPassengerGender, getPassengerType, getparamsString } from '../common/helper';
const RefundDtls = (props) => {
    const [refund, setRefundData] = useState({});
    const [refundDetail, setRefundDetail] = useState({});
    const [bookingData, setBookingData] = useState(false);
    const [PaxDetail, setPaxDetail] = useState([]);
    const [loader, setLoader] = useState(false);

    const pnr = props.pnr;
    const mobile = props.mobile;

    useEffect(() => {
        if (bookingData.PaxDetail) {
            setPaxDetail([...bookingData.PaxDetail]);
        }
    }, [bookingData]);

    useEffect(() => {
        if (pnr) {
            const data = {
                PNR: pnr,
                mobile: mobile
            };
            setLoader(true);
            const url = apiUrl.bookingInfo + "?" + getparamsString(data);
            GetRequest(url)
                .then((res) => {
                    setLoader(false);
                    if (res.Status && !res.Error) {
                        setBookingData(res.BookingInfo.APIGetBookingDetailsResult[0]);
                        setRefundData(res.BookingInfo.APIGetBookingDetailsResult[0].RefData[0] || {})
                        setRefundDetail(res.BookingInfo.APIGetBookingDetailsResult[0].RefundDetail[0] || {})
                    }
                })
                .catch((err) => {
                    console.log(err);
                    setLoader(false);
                });
        }
    }, []);

    const getLevy = (fare) => {
        const {
            BridgeFee = 0,
            EntryFee = 0,
            InfraFee = 0,
            InsuranceFee = 0,
            TollFee = 0,
            UserFee = 0,
        } = fare;
        return (
            BridgeFee + EntryFee + InfraFee + InsuranceFee + TollFee + UserFee
        );
    };

    const getLevyRefund = (fare) => {
        const {
            BridgeFee = 0,
            EntryFee = 0,
            InfraFee = 0,
            InsuranceFeee = 0,
            TollFee = 0,
            UserFee = 0,
        } = fare;
        return (
            BridgeFee + EntryFee + InfraFee + InsuranceFeee + TollFee + UserFee
        );
    };
    // const getLevyRefund = (fare) => {
    //     const {
    //         IsBridgeFeeRef,
    //         IsEntryFeeRef,
    //         IsInfraFeeRef,
    //         IsInsuranceFeeRef,
    //         IsTollFeeRef,
    //         IsUserFeeRef,
    //     } = fare;
    //     const {
    //         BridgeFeeRef = 0,
    //         EntryFeeRef = 0,
    //         InfraFeeRef = 0,
    //         InsuranceFeeeRef = 0,
    //         TollFeeRef = 0,
    //         UserFeeRef = 0,
    //     } = fare;
    //     let levyRefund = 0;
    //     if (IsBridgeFeeRef) {
    //         levyRefund += BridgeFeeRef;
    //     }
    //     if (IsEntryFeeRef) {
    //         levyRefund += EntryFeeRef;
    //     }
    //     if (IsInfraFeeRef) {
    //         levyRefund += InfraFeeRef;
    //     }
    //     if (IsInsuranceFeeRef) {
    //         levyRefund += InsuranceFeeeRef;
    //     }
    //     if (IsTollFeeRef) {
    //         levyRefund += TollFeeRef;
    //     }
    //     if (IsUserFeeRef) {
    //         levyRefund += UserFeeRef;
    //     }
    //     return levyRefund;
    // };
    return (
        <>
            {loader && <Loader />}
            <div className='pax--container'>
                <div className="passenger--details" >
                    <div className="passenger--table">
                        <div className="passenger--head">
                            <div style={{ width: '20%' }}>ಹೆಸರು / <br /> Passenger Name</div>
                            <div style={{ width: '15%' }}>ಆಸನ ಸಂಖ್ಯೆ / <br /> Seat No.</div>
                            <div style={{ width: '15%' }}>ವಯಸ್ಸು / <br /> Age</div>
                            <div style={{ width: '15%' }}>ವಯಸ್ಕರು / ಮಕ್ಕಳು / <br /> Adult / Child</div>
                            <div style={{ width: '15%' }}>ಲಿಂಗ / <br /> Gender</div>
                            <div style={{ width: '20%' }}>ರಿಯಾಯಿತಿ  ವಿಧ /<br /> Concession Type</div>
                        </div>
                        {PaxDetail.map((data, index) => (
                            <div className="passenger--row" key={`pass_${index}`}>
                                <div style={{ width: '20%' }}>{data.PaxName}</div>
                                <div style={{ width: '15%' }}>{data.SeatNo}</div>
                                <div style={{ width: '15%' }}>{data.Age}</div>
                                <div style={{ width: '15%' }}>{getPassengerType(data.Age)}</div>
                                <div style={{ width: '15%' }}>{getPassengerGender(data.Gender)}</div>
                                <div style={{ width: '20%' }}>{data.ConcessionTypeName}</div>
                            </div>
                        ))}
                    </div>
                    {refund &&
                        <>
                            <div className="fare--table">
                                <div style={{ fontWeight: 500, padding: '20px 0px 12px 0' }}>
                                    ಪ್ರಯಾಣಿಕರ ವಿವರಗಳು / Refund Break up
                                </div>
                                <div className="fare--head">
                                    <div>ವಿವರಣೆ / <br /> Description</div>
                                    <div>ಮೂಲ ವಹಿವಾಟು (₹) / <br /> Original Transaction (₹)</div>
                                    <div>ಮರುಪಾವತಿಸಲು (₹) / <br /> To Be Refunded (₹)</div>
                                    <div>ರದ್ದತಿ ಶೇಕಡಾವಾರು (%) / <br /> Cancellation Percentage (%)</div>
                                </div>

                                <div className="fare--row">
                                    <div>ಪ್ರಯಾಣ ದರ / Journey Fare</div>
                                    <div>₹{bookingData?.TotalBaseFare}</div>
                                    <div>₹{refund?.BaseFare}</div>
                                    <div>{refund.ChargePct}%</div>
                                </div>

                                <div className="fare--row">
                                    <div>ಮೀಸಲಾತಿ ಶುಲ್ಕ / Reservation Fee</div>
                                    <div>₹{bookingData?.SRTFee}</div>
                                    <div>₹{refund.SRTFee}</div>
                                    <div>{"-"}</div>
                                </div>

                                <div className="fare--row">
                                    <div>ಇತರೆ ಲೆವಿಗಳು / Other Levies</div>
                                    <div>₹{getLevy(bookingData)}</div>
                                    <div>₹{getLevyRefund(refund)}</div>
                                    <div>{"-"}</div>
                                </div>

                                <div className="fare--row">
                                    <div>ಜಿಎಸ್ಟಿ / GST</div>
                                    <div>₹{bookingData.Tax}</div>
                                    <div>₹{refund.Gst}</div>
                                    <div>{"-"}</div>
                                </div>
                                <div className="fare--row">
                                    <div>ಕಡಿಮೆ ರಿಯಾಯಿತಿ / Less Discount</div>
                                    <div>₹{bookingData.ConcessionAmount}</div>
                                    <div>₹{refund.ConcessionAmount}</div>
                                    <div>{"-"}</div>
                                </div>
                                <div className="fare--row">
                                    <div>ಪಾವತಿ ಗೇಟ್‌ವೇ ಶುಲ್ಕಗಳು / Payment Gateway Charges</div>
                                    <div>₹{0}</div>
                                    <div>₹0</div>
                                    <div>{"-"}</div>
                                </div>
                                <div className="fare--row">
                                    <div>ಒಟ್ಟು / Total</div>
                                    <div>₹{bookingData.TotalAmountPaid}</div>
                                    <div>₹{refund.RefundAmountNet}</div>
                                    <div>{"-"}</div>
                                </div>
                            </div>
                            
                        </>
                    }

                    {
                        refundDetail && 
                        <>
                            <div className="refund--table">
                                <div style={{ fontWeight: 500, padding: '20px 0px 12px 0' }}>
                                    ಮರುಪಾವತಿ ವಿವರ / Refund Details
                                </div>
                                <div className="refund--head">
                                    <div>ಪೇಮೆಂಟ್‌ ಗೇಟ್‌ ವೇ ಮರುಪಾವತಿ ಐಡಿ /<br/> PGW Refund ID</div>
                                    <div>ಮುಪಾವತಿ ಮೊತ (₹) / <br/> Refund Amount (₹)</div>
                                    <div>ಮರುಪಾವತಿ ದಿನ ಮತ ಸಮಯ / <br/> Refund Creation Date and Time</div>
                                    <div>ಮರುಪಾವತಿ ಸ್ಥಿತಿ <br/> Refund Status</div>
                                    <div>ARN/RRN/UTR</div>
                                </div>

                                <div className="refund--row">
                                    <div>{refundDetail?.PGTransactionID}</div>
                                    <div>{refundDetail?.RefAmount}</div>
                                    <div>{refundDetail?.RefundInitDate}</div>
                                    <div>{refundDetail?.RefStatus}</div>
                                    <div>{refundDetail?.ARN}</div>
                                </div>
                            </div>
                        </>
                    }
                </div>
            </div>
        </>
    )
}

export default RefundDtls;